import { AfterViewInit, Directive, ElementRef, HostBinding, Input, Renderer2 } from '@angular/core';

/**
 * Implements a floating label for 'nz-select' and 'nz-date-picker'
 *
 * - When using in a form, you have to manually notify Angular to update the view, ie
 * the current view of the inserted label. The best place to do this is in the form
 * valueChanges.
 *
 * ## EXAMPLE
 * ```
 * public ngAfterViewInit(): void {
 *     this.form.valueChanges.pipe(startWith(null)).subscribe(() => this.cdr.detectChanges());
 * }
 * ```
 *
 */
@Directive({
	selector: '[appFloatingLabelSelect]'
})
export class FloatingLabelSelectDirective implements AfterViewInit {
	@Input() public appFloatingLabelSelect = '';
	private tagName = '';

	constructor(public el: ElementRef, public renderer: Renderer2) {
	}

	@HostBinding('class.floated')
	public get floated(): boolean {
		const htmlElement = this.el.nativeElement as HTMLElement;
		let result = false;
		switch (this.tagName) {
			case 'NZ-DATE-PICKER':
				const inputElement: HTMLInputElement = htmlElement.querySelector('input');
				result = Boolean(inputElement.getAttribute('ng-reflect-model'));
				break;
			case 'NZ-SELECT':
				result = Boolean(htmlElement.querySelector('nz-select-item'));
		}
		return result;
	}

	public ngAfterViewInit(): void {
		const htmlElement = this.el.nativeElement as HTMLElement;
		this.tagName = this.el.nativeElement.tagName.toUpperCase();
		const label = this.createLabel();
		switch (this.tagName) {
			case 'NZ-DATE-PICKER':
				const inputElement: HTMLInputElement = htmlElement.querySelector('input');
				this.renderer.setAttribute(inputElement, 'placeholder', '');
				this.renderer.addClass(htmlElement, 'is-date-picker');
				this.renderer.appendChild(htmlElement, label);
				break;
			case 'NZ-SELECT':
				this.renderer.appendChild(htmlElement, label);
		}
	}

	private createLabel(): HTMLElement {
		const label = this.renderer.createElement('span');
		const textNode = this.renderer.createText(this.appFloatingLabelSelect);
		this.renderer.appendChild(label, textNode);
		this.renderer.addClass(label, 'floating-label');
		return label;
	}
}
